module.exports = {"511403001":"凤鸣街道","511403003":"青龙街道","511403004":"观音街道","511403006":"谢家街道","511403007":"江口街道","511403110":"锦江镇","511403118":"公义镇","511403121":"黄丰镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511403.json
// module id = 2481
// module chunks = 0